import React, { useContext, useEffect, useState } from 'react';
import { Container, Dropdown } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import { RiAddLine } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom'; 

import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar';
import HomeEC from '../pros/ec_prosess';
import HomeNl from '../pros/nl_process';
import HomeDoc from '../pros/doc_process';
import { AuthContext } from '../../context/authContext';

import '../css/others/home.css';

const Home = () => {
    const [view, setView] = useState('doc');
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (location.state?.mountSection) {
            setView(location.state.mountSection);
            
            // Optional: Clear the state after reading it so a refresh 
            // doesn't keep forcing the tab if the user switches manually.
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    
    const tabs = [
        { id: 'doc', label: 'Document', component: <HomeDoc /> },
        { id: 'nl', label: 'Nagal', component: <HomeNl /> },
        { id: 'ec', label: 'Encumbrance Certificate(EC)', component: <HomeEC /> }
    ];

    // Function to handle toggle (passed to Sidebar if needed, or matched via CSS)

    return (
        <div className="dashboard-page">
            <Header />
            <ToastContainer autoClose={3000} />

            <div className={`dashboard-wrapper `}>
                {/* Pass a toggle handler if you modify Sidebar to accept it, 
                   otherwise the CSS below will handle the width change 
                */}
                <div className='d-none' style={{backgroundColor:"#4a127e"}}>
                    <Sidebar user={user} />
                </div>

                <main className="main-area">
                    <Container fluid="xxl" className="py-4 px-3 px-md-5">
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="main-glass-card shadow-lg"
                        >
                            <div className="custom-tab-header">
                                <div className="tabs-left-group">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab.id}
                                            className={`tab-btn ${view === tab.id ? 'active' : ''}`}
                                            onClick={() => setView(tab.id)}
                                        >
                                            {tab.label}
                                            {view === tab.id && (
                                                <motion.div 
                                                    layoutId="activeTab" 
                                                    className="active-underline" 
                                                />
                                            )}
                                        </button>
                                    ))}
                                </div>

                                <Dropdown align="end">
                                    <Dropdown.Toggle as="div" className="add-btn-toggle">
                                        <RiAddLine size={28} color='white' />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="modern-dropdown-menu" style={{color:"white"}}>
                                        <Dropdown.Item onClick={() => navigate('/register')}>Document Registration</Dropdown.Item>
                                        <Dropdown.Item onClick={() => navigate('/ec_register')}>EC Registration</Dropdown.Item>
                                        <Dropdown.Item onClick={() => navigate('/nl_register')}>Nagal Registration</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                            <div className="content-body">
                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={view}
                                        initial={{ opacity: 0, x: 15 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -15 }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        {tabs.find(t => t.id === view).component}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    </Container>
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default Home;